import { useContext } from "react";
import { SocketContext } from "../contexts/contextExporter";

export const useSocket = () => {
  return useContext(SocketContext);
};
